import { apiEmpleo } from "../../../../../util/ApiEmpleo";

export type TApiSyncCandidateAttachmentsResponse = {
  dispatched: boolean;
};

/**
 * Asks the backend to import, asynchronously, the candidate's Zoho attachments.
 */
export const apiSyncCandidateAttachments = async (candidateId: string) => {
  const res: TApiSyncCandidateAttachmentsResponse = await apiEmpleo.post(
    `candidatos/${candidateId}/attachments/sync`,
    {},
    undefined,
    false
  );

  return res;
};
